module.exports = "tr {\r\n\tcursor: pointer; \r\n}\r\n\r\n.canceled{\r\n  text-decoration: line-through;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/calibrations/calibration-list/calibration-list.component.css
// module id = ./src/app/calibrations/calibration-list/calibration-list.component.css
// module chunks = main